<template>
<v-layout>
  <v-flex xs10 offset-xs1>
  <v-card>
    <v-card-title>
      <!-- <v-btn color="info">Add New Country</v-btn> -->
      <v-dialog v-model="dialog" scrollable max-width="300px">
      <v-btn color="info" href="#/country/update" slot="activator" @click="getNewCountry()">Add Country</v-btn>
      <v-card>
        <v-card-title>
          <div>
            <h3 class="title">Select Country</h3>
            <h5 color="info" class="caption">Please select at least one country.</h5>
          </div>
        </v-card-title>



        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-text-field
            v-model="countryQuery"
            label="Search Country"
          ></v-text-field>

          <v-radio-group v-model="selectedCountry" column>
            <v-radio v-for= "cont in filteredCountry" :key="cont.alpha2Code" :label="cont.name + ' - ' + cont.iso" :value="cont"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn @click.native="dialog = false;">Close</v-btn>
          <v-btn color="primary" @click="addNewCountry">Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-spacer></v-spacer>
    <v-text-field
      v-model="search"
      append-icon="search"
      label="Search..."
      single-line
      hide-details
    ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="addedCountries"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.iso }}</td>
        <td class="text-xs-right">{{ props.item.code }}</td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Sorry!!! No result found for your search "{{ search }}".
      </v-alert>
    </v-data-table>
  </v-card>
  </v-flex>
  </v-layout>
</template>
<script>
  import axios from 'axios'
  import { SERVER_URL } from './../../constant.js'

  export default {
    data () {
      return {
        selectedCountry: '',

        dialog: false,
        search: '',
        headers: [
          {
            text: 'Name',
            value: 'name',
            align: 'left'
          },
          { 
            text: 'ISO', 
            value: 'iso',
            align: 'center',
            sortable: false
          },
          { 
            text: 'Country Code',
            value: 'code',
            align: 'center',
            sortable: false
          }
        ],
        countries: [],
        addedCountries: [],
        filteredCountry: [],
        countryQuery: ''
      }
    },
    created() {
      document.title = 'Country';
      axios.get(`${SERVER_URL}/country/all`).then(res => {
        this.addedCountries = res.data.map(val => {
          return {iso: val.iso, name: val.name, code: val.code};
        })
      })
    },
    watch: {
      'countryQuery' : function (val) {
        if (val) {
          // filter country.
          this.filteredCountry = [];
          this.countries.forEach(country => {
            if (country.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              this.filteredCountry.push({iso: country.iso, name: country.name, code: country.code});
            }
          })
          
        } else {
          // Assign with all country.
          this.filteredCountry = this.countries.map(country => {
            return {iso: country.iso, name: country.name, code: country.code};
          })
        }
      }
    },
    methods: {
      getNewCountry() {
        axios.get('https://restcountries.eu/rest/v2/all').then(res => {
          res.data.forEach(val => {
            this.countries.push({ iso: val.alpha2Code, name: val.name, code: val.callingCodes[0]});
            this.filteredCountry.push({ iso: val.alpha2Code, name: val.name, code: val.callingCodes[0]});
          })
        })
      },
      addNewCountry() {
        
        var vm = this;
        if (!vm.selectedCountry) {
          document.dispatchEvent(new CustomEvent('showSnackbarEvent', {detail: 'Please select at least one country from list.'}));
        } else if (this.addedCountries.find(ac => ac.iso == vm.selectedCountry.iso)) {
          document.dispatchEvent(new CustomEvent('showSnackbarEvent', {detail: 'Country already added.'}));
          vm.dialog = false;
        } else {
          axios.post(`${SERVER_URL}/country/add`, {
            name: vm.selectedCountry.name,
            code: vm.selectedCountry.code,
            iso: vm.selectedCountry.iso,
            status: 'Active'
          })
          .then(function (res) {
            vm.addedCountries.push({ iso: res.data.iso, name: res.data.name, code: res.data.code});
            var showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'Country added successfylly.'})
            document.dispatchEvent(showSnackbarEvent)
          })
          .catch(function (error) {
            console.log(error);
          });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/country/CountryMng.vue